import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../Assets/Css/MyTest.css";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import backIcon from "../../Assets/Images/Expand_left.png";
import clockIcon from "../../Assets/Images/SVG/clockpc.svg";
import calendarIcon from "../../Assets/Images/SVG/mycalendar.svg";
import editIcon from "../../Assets/Images/SVG/edit.svg";
import alarmClockIcon from "../../Assets/Images/alarm-clock.png";
import bloodPressureIcon from "../../Assets/Images/BloodPressureIcon.png";
import bloodSugarIcon from "../../Assets/Images/BloodSugar.png";
import config from "../../Config";

const MyTest = () => {
  const navigate = useNavigate();
  const [tests, setTests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showAll, setShowAll] = useState(false);
  const [toggleState, setToggleState] = useState({});

  const visibleCardsCount = 3; // Number of cards visible before "...more"

  useEffect(() => {
    const fetchTests = async () => {
      const token = sessionStorage.getItem("authToken");
      const patientId = sessionStorage.getItem("patientid");

      if (!token || !patientId) {
        navigate("/signin");
        return;
      }

      try {
        const response = await fetch(
          `${config.API_BASE_URL}/patient/test/${patientId}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error(`Failed to fetch tests: ${response.statusText}`);
        }

        const data = await response.json();
        setTests(data.data || []);

        // Initialize all toggles to 'Off'
        setToggleState(
          data.data.reduce(
            (state, test) => ({ ...state, [test.test_name]: false }),
            {}
          )
        );
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTests();
  }, [navigate]);

  const updateReminderStatus = async (testName, status, testId, category) => {
    const token = sessionStorage.getItem("authToken");
    const userId = sessionStorage.getItem("patientid");

    if (!token || !userId) {
      navigate("/signin");
      return;
    }

    try {
      const response = await fetch(
        `${config.API_BASE_URL}/patient/reminder/status`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: "2",                
            category: "tests",      
            reminder_status: "1",   // Reminder status, 1 for on, 0 for off
            user_id: "1",           // User ID
            patient_id: "1",        // Patient ID
            reminder_part: "morning" // Reminder part (e.g., morning, afternoon)
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`Failed to update reminder status: ${response.statusText}`);
      }

      const data = await response.json();
      console.log(`Reminder status updated successfully for ${testName}:`, data);
    } catch (err) {
      console.error("Error updating reminder status:", err.message);
    }
  };

  const handleToggleClick = (test) => {
    const newStatus = !toggleState[test.test_name];

    setToggleState((prevState) => ({
      ...prevState,
      [test.test_name]: newStatus,
    }));

    updateReminderStatus(test.test_name, newStatus, test.id, test.category);
  };

  const handleShowAll = () => {
    setShowAll(!showAll);
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  const handleViewLogClick = () => {
    navigate("/test-log");
  };

  const handleAddLogClick = () => {
    navigate("/add-test");
  }; 

  const handleUpdateClick = () => {
    navigate("/update-test");
  }

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <div>
      <Header />
      <div className="treminder-container">
        <div className="sub-header">
          <button className="back-button">
            <img
              src={backIcon}
              alt="Back"
              className="back-icon"
              onClick={handleBackClick}
            />
          </button>
          <h1 className="title-mytest">My Tests</h1>
        </div>

        <div className="mytest-button-group">
          <button className="add-button" onClick={handleAddLogClick}>
            + Add
          </button>
          <button className="view-log-button" onClick={handleViewLogClick}>
            View Log
          </button>
        </div>

        <div className={`treminder-list ${showAll ? "expanded" : ""}`}>
          {(showAll ? tests : tests.slice(0, visibleCardsCount)).map((test) => (
            <div key={test.id} className="treminder-card">
              <div className="treminder-row">
                <img
                  src={
                    test.test_name === "Blood Pressure"
                      ? bloodPressureIcon
                      : bloodSugarIcon
                  }
                  alt={`${test.test_name} Icon`}
                  className="treminder-icon"
                />
                <div className="treminder-content">
                  <h2>{test.test_name}</h2>
                  <div className="treminder-info">
                    <img src={clockIcon} alt="Clock Icon" />
                    <span>{test.reminder_time?.[0]?.test_time || "--:--:--"}</span>
                  </div>
                  {test.reminder && (
                    <div className="treminder-info">
                      <img src={calendarIcon} alt="Calendar Icon" />
                      <span>{test.reminder}</span>
                    </div>
                  )}
                </div>
                <button className="edit-button">
                  <img src={editIcon} alt="Edit Icon" onClick={handleUpdateClick}/>
                </button>
              </div>

              <div className="treminder1-row">
                <img
                  src={alarmClockIcon}
                  alt="Alarm Clock Icon"
                  className="alarm-clock-icon"
                />
                <div
                  className={`toggle ${
                    toggleState[test.test_name] ? "on" : "off"
                  }`}
                  onClick={() => handleToggleClick(test)}
                >
                  {toggleState[test.test_name] ? "On" : "Off"}
                </div>
              </div>
            </div>
          ))}
        </div>

        {tests.length > visibleCardsCount && (
          <button className="show-all-button" onClick={handleShowAll}>
            {showAll ? "Show Less" : "Show More"}
          </button>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default MyTest;
